module.exports = __webpack_public_path__ + "assets/img/1.07256253.jpg";